import PropTypes from "prop-types";
import { createContext, useState, useEffect } from "react";
import { LOCAL_STORAGE_TOKENS } from "../utils/constants";

// ----------------------------------------------------------------------

const initialState = {
  uuid: "",
  name: "",
};

const ClientContext = createContext({
  selectedClient: initialState,
  setSelectedClient: () => {},
});

// ----------------------------------------------------------------------

ClientProvider.propTypes = {
  children: PropTypes.node,
};

function ClientProvider({ children }) {
  const { localKey_selectedClient } = LOCAL_STORAGE_TOKENS;
  const [selectedClient, setSelectedClient] = useState(() => {
    const storedClientData = localStorage.getItem(localKey_selectedClient);
    try {
      return storedClientData ? JSON.parse(storedClientData) : initialState;
    } catch (error) {
      console.error("Failed to parse selectedClient from localStorage:", error);
      return initialState;
    }
  });

  useEffect(() => {
    const timer = setTimeout(() => {
      localStorage.setItem(
        localKey_selectedClient,
        JSON.stringify(selectedClient)
      );
    }, 300);
    return () => clearTimeout(timer);
  }, [selectedClient, setSelectedClient]);

  return (
    <ClientContext.Provider
      value={{
        selectedClient,
        setSelectedClient,
      }}
    >
      {children}
    </ClientContext.Provider>
  );
}

export { ClientProvider, ClientContext };
